import { render, staticRenderFns } from "./CertificateFileFor.vue?vue&type=template&id=cb4e0222&scoped=true&lang=html&"
import script from "./CertificateFileFor.vue?vue&type=script&lang=js&"
export * from "./CertificateFileFor.vue?vue&type=script&lang=js&"
import style0 from "./CertificateFileFor.vue?vue&type=style&index=0&id=cb4e0222&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4e0222",
  null
  
)

export default component.exports